import { Component, inject } from '@angular/core';
import { ToggleService } from '../header/toggle.service';
import { CustomizerSettingsService } from '../../customizer-settings/customizer-settings.service';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { NgClass } from '@angular/common';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { MatExpansionModule } from '@angular/material/expansion';
import { AuthService } from '../../../core/services/auth.service';
import { MatIconModule } from '@angular/material/icon';
import { LocationStore } from '../../../store/location.store';
import { LoadingComponent } from '../../../shared/components/loaing/loading.component';
import { AppStore } from '../../../store/app.store';

@Component({
    selector: 'app-sidebar',
    imports: [
        RouterLink,
        NgClass,
        NgScrollbarModule,
        MatExpansionModule,
        RouterLinkActive,
        MatIconModule,
        LoadingComponent,
    ],
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent {
    public readonly locationStore = inject(LocationStore);
    public readonly appStore = inject(AppStore);

    panelOpenState = false;

    isToggled = false;

    constructor(
        private readonly toggleService: ToggleService,
        public themeService: CustomizerSettingsService,
        private readonly authService: AuthService
    ) {
        this.toggleService.isToggled$.subscribe((isToggled) => {
            this.isToggled = isToggled;
        });
    }

    toggle() {
        this.toggleService.toggle();
    }

    toggleSidebarTheme() {
        this.themeService.toggleSidebarTheme();
    }

    toggleHideSidebarTheme() {
        this.themeService.toggleHideSidebarTheme();
    }

    logout() {
        this.appStore.startLoading();
        this.authService
            .logout(this.authService.getOauthDetail()?.userID)
            .subscribe({
                next: () => {
                    this.appStore.stopLoading();
                },
                error: (error) => {
                    this.appStore.stopLoading();
                },
            });
    }
}
